import React from 'react';
import { string } from 'prop-types';
import { Trans } from 'react-i18next';

import { useDateToString } from '../../../Element/DateToString';
import { formatTimeToHMM } from '../../../../helpers/Formatter/TimeFormatter';

const TimeInfo = ({ arrivalTime, startTime, duration, endTime, timeZone }) => {
  const DateToString = useDateToString();

  return (
    <div className={'account-session-detail__date'}>
      <p className="account-session-detail-text">
        <Trans>account.session.detail.time-info.date-and-time-of-session</Trans>
      </p>
      <p className={'account-session-detail__date-day'}>
        <DateToString date={arrivalTime} timezone={timeZone} format="dddd LL" />
      </p>
      <ul className={'account-session-detail__date-schedule'}>
        <li>
          <strong>
            <DateToString date={arrivalTime} timezone={timeZone} format="LT" />
          </strong>
          <span>
            <Trans>account.session.detail.time-info.arrival-of-candidates</Trans>
          </span>
        </li>
        <li className="account-session-detail__date-schedule-separator" />
        <li>
          <strong>
            <DateToString date={startTime} timezone={timeZone} format="LT" />
          </strong>
          <span>
            <Trans>account.session.detail.time-info.beginning-session</Trans>
          </span>
        </li>
        <li className="account-session-detail__date-schedule-separator" />
        <li>
          <strong>
            <DateToString date={endTime} timezone={timeZone} format="LT" />
          </strong>
          <span>
            <Trans>account.session.detail.time-info.estimated-time-of-release</Trans>
          </span>
        </li>
      </ul>
      <p className="account-session-detail-text">
        <Trans>account.session.detail.time-info.duration-session</Trans>{' '}
        <strong>{formatTimeToHMM(duration * 60000)}</strong>
      </p>
    </div>
  );
};

TimeInfo.propTypes = {
  arrivalTime: string.isRequired,
  startTime: string.isRequired,
  endTime: string.isRequired,
  duration: string.isRequired,
  timeZone: string.isRequired,
};

export default TimeInfo;
